// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__cOM5N","selects":"Documents_selects__2Te-B"};